// usePageListDetails.ts
// src/hooks/PageHooks/usePageListDetails.ts
import { useState, useEffect } from "react";
import { getPageMeta } from "../api/toga";
import { PageMeta } from "./usePageDetails";

export default function usePageListDetails(
	slug: string,
	enabled: boolean = true
) {
	const [pageMeta, setPageMeta] = useState<PageMeta | null>(null);
	const [isLoadingMeta, setIsLoadingMeta] = useState(false);
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		if (!enabled || !slug) return;

		let cancelled = false;
		setIsLoadingMeta(true);
		setIsError(false);

		(async () => {
			try {
				const meta = await getPageMeta(slug);
				if (cancelled) return;

				setPageMeta(meta);
			} catch (err: any) {
				if (cancelled) return;
				// axios-style error object:
				const status = err.response?.status;
				const data = err.response?.data;
				console.error(
					`❌ fetchPageMeta failed for slug "${slug}":`,
					"\nStatus:",
					status,
					"\nResponse body:",
					data ?? err.message
				);
				setIsError(true);
			} finally {
				if (!cancelled) setIsLoadingMeta(false);
			}
		})();

		return () => {
			cancelled = true;
		};
	}, [slug, enabled]);

	return { pageMeta, isLoadingMeta, isError };
}
